import script from "./RcButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcButton.vue?vue&type=script&setup=true&lang=ts"

import "./RcButton.vue?vue&type=style&index=0&id=1d8b5592&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d8b5592"]])

export default __exports__